<template>
  <div class="col-md-12 ps-0 wrapper-filtros2 py-3 pe-0">
    <div class="col-12 font-ARB pe-0 ps-0">
      <div class="d-flex justify-content-center justify-content-md-between align-items-center">
        <h3 class="title title-mod text_green text-nowrap font-PB">Próximos remates</h3>
        <div class="d-none d-md-flex align-items-center">
          <a href="https://www.galicia.ar/empresas/financiaciones/compra-insumos-agro?utm_campaign=agro_galiciaagro&utm_source=lanacion&utm_medium=display&utm_content=logo&utm_strategy=brnd&dclid=CMTD2b-D8PICFVYmuQYdpH4I4A"
            target="_blank" class="brand-anexo pb-0 pt-0 mt-0">
            <img class="img-brand py-1" src="/images/brands/logo_galicia.png" alt="Galicia">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    const today = new Date(); // Fecha de hoy
    const calculatedMinDate = new Date(
      today.getFullYear(),
      today.getMonth() - 6,
      today.getDate()
    );
    this.minDate = calculatedMinDate
  },
  props: ['remates', 'tipos'],
  methods: {
    submit: function () {
      let url = '/remates?';

      for (let param in this.form) {
        if (this.form[param] != null) {
          if (param === 'desde' || param === 'hasta') {
            // Convertir la fecha a YYYY-MM-DD
            const formattedDate = this.form[param].toISOString().split('T')[0];
            url += `${param}=${formattedDate}&`;
          } else {
            url += `${param}=${this.form[param]}&`;
          }
        }
      }

      window.open(url, '_blank');
    },
    formatDate(date) {
      if (!date) return '';

      const day = date.getDate().toString().padStart(2, '0');
      const month = date.toLocaleString('default', { month: 'long' });
      const finalMonth = month.charAt(0).toUpperCase() + month.slice(1);
      const year = date.getFullYear();

      return `${day} ${finalMonth} ${year}`;
    }
  },
  data() {
    return {
      submitted: false,
      dateColor: '#949494',
      form: {
        tipo: null,
        desde: null,
        hasta: null
      },
      minDate: null,
    }
  }
};

</script>
<style lang="scss"></style>